import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import styles from './TokenConfirmationDialog.module.css'; // We will create this CSS module

interface TokenConfirmationDialogProps {
  open: boolean;
  remainingTokens: number;
  onClose: () => void;
  onConfirm: () => void; // This will call handleConfirmTokenSpendOrGetFullProfile(true)
  onPurchaseTokens: () => void;
}

const TokenConfirmationDialog: React.FC<TokenConfirmationDialogProps> = ({
  open,
  remainingTokens,
  onClose,
  onConfirm,
  onPurchaseTokens,
}) => {
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      disablePortal
      PaperProps={{
        className: styles.dialogPaper,
        style: { zIndex: 1301 } // MUI Modals are typically 1300, ensure this is higher than other elements
      }}
      sx={{ zIndex: 1301 }} // Also try sx prop for direct style override for the backdrop/root
    >
      <DialogTitle className={styles.dialogTitle}>Confirm Token Spend</DialogTitle>
      <DialogContent className={styles.dialogContent}>
        <Typography variant="subtitle1" className={styles.tokensRemainingText}>
          Tokens remaining: {remainingTokens}
        </Typography>
        <Link component="button" variant="body2" onClick={onPurchaseTokens} className={styles.purchaseTokensLink}>
          Purchase Tokens
        </Link>
        <DialogContentText className={styles.dialogBodyText}>
          You are about to spend 1 token to view this candidate's full contact information. This will allow you to:
        </DialogContentText>
        <List dense className={styles.benefitsList}>
          {[
            'See their full name and credentials',
            'Access their phone number and email',
            'View their complete address',
            'See their license number',
          ].map((text, index) => (
            <ListItem key={index} disablePadding className={styles.listItem}>
              <ListItemIcon className={styles.listItemIcon}>
                <CheckIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary={text} className={styles.listItemText}/>
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions className={styles.dialogActions}>
        <Button onClick={onClose} className={styles.cancelButton} variant="outlined">
          Cancel
        </Button>
        <Button onClick={onConfirm} className={styles.confirmButton} variant="contained" color="primary" autoFocus>
          Spend Token
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TokenConfirmationDialog; 